import { z } from 'zod';
import { TRACKING_LIMITS } from './tracking-limits';

/** A tracking string that is truncated to `max` chars, never rejected for length. */
export function truncatedTrackingString(max: number) {
  return z.string().transform((value) => value.slice(0, max));
}

/** pageUri / referrer / landingReferrer: truncated at TRACKING_LIMITS.url. */
export const trackingUrl = truncatedTrackingString(TRACKING_LIMITS.url);

/** Attribution sent by forms without a gclid (contributor, partner). */
export const trackingSchema = z.object({
  pageUri: trackingUrl.optional(),
  referrer: trackingUrl.optional(),
  landingReferrer: trackingUrl.optional(),
  landingUri: truncatedTrackingString(TRACKING_LIMITS.landingUri).optional(),
});

/** Attribution sent by lead forms (quote, contact, eBook), including the gclid. */
export const leadTrackingSchema = trackingSchema.extend({
  gclid: truncatedTrackingString(TRACKING_LIMITS.gclid).optional(),
});
